<template>
    <div class="login-container login-page">
        <div class="login-header login-caret">
            <h1>{{ $t('no_cookies') }}</h1>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        computed: {
            ...mapGetters([
                'localStorageAvailable',
            ]),
        },
        created() {
            if(this.localStorageAvailable){
                this.$router.push({ name: 'dashboard' });
            }
        }
    }
</script>

<style scoped>
    .login-container.login-page{
        height: 100%;
    }
    h1{
        color: white;
        text-align: center;
        font-weight: 900;
    }
</style>